import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../../../context/AppContext";
import noData from "../../../../assets/errors/noData.png";
//primer react
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { SplitButton } from "primereact/splitbutton";
//components
import Input from "../../../../components/input/Input";
import Modal from "../../../../components/modal/Modal";
import FileInput from "../../../../components/input/FileInput";
import CardDocument from "../../../../components/cards/CardDocument";
//services
import { getEnterpriseDrive } from "../../../../services/Enterprise/Documents/getEnterpriseDrive";
import { postEnterpriseFolder } from "../../../../services/Enterprise/Documents/postEnterpriseFolder";
import { postEnterpriseDrive } from "../../../../services/Enterprise/Documents/postEnterpriseDrive";
import { formatDate } from "../../../../utils/formatDate";
import { queryClient } from "../../../../utils/queryClient";
import { Skeleton } from "primereact/skeleton";
import { Card } from "primereact/card";
import { deleteDocumentsContracts } from "../../../../services/Contracts/deleteDocumentsContracts";
import { deleteFolder } from "../../../../services/Enterprise/Documents/deleteFolder";

const Documents = () => {
  const { id } = useParams();
  const { permissions } = useAppContext();

  const spreadsheet = [
    {
      label: "Arquivo",
      icon: "fa fa-file",
      color: "success",
      command: () => {
        showFile("center");
      },
    },
    {
      label: "Pasta",
      icon: "fa fa-folder",
      command: () => {
        show("top-right");
      },
    },
  ];

  const defaultValuesPaste = {
    newPaste: "Nova Pasta",
  };

  const defaultValuesFile = {
    newArchive: "Novo Arquivo",
  };

  const formPaste = useForm({ defaultValuesPaste });
  const errorsPaste = formPaste.formState.errors;
  const formFile = useForm({ defaultValuesFile });
  const errorsFile = formFile.formState.errors;

  // const [currentFolder, setCurrentFolder] = useState(null);
  const [visible, setVisible] = useState(false);
  const [fileVisible, setFileVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [position, setPosition] = useState("center");
  const [document, setDocument] = useState("");
  const [currentFolder, setCurrentFolder] = useState(null); // Pasta atual
  const [currentFolderId, setCurrentFolderId] = useState(null); // Pasta atual
  const [items, setItems] = useState([]);

  const {
    data: documents,
    isLoading: loadingDocuments,
    refetch: refetchDocuments,
  } = useQuery({
    queryKey: [`documents${id}`],
    queryFn: () => getEnterpriseDrive(id),
    enabled: !!permissions?.includes("22"),
  });

  useEffect(() => {
    //    console.log(documents);
    const findParentFolder = (folders, parentId) => {
      for (let folder of folders) {
        if (folder.id === parentId) {
          return folder;
        }
        if (folder.children_folder && folder.children_folder.length > 0) {
          const parent = findParentFolder(folder.children_folder, parentId);
          if (parent) {
            return parent;
          }
        }
      }
      return null;
    };

    if (currentFolder) {
      const buildBreadcrumbs = (folder) => {
        let breadcrumbs = [];
        let current = folder;
        while (current) {
          if (current && current.name) {
            const currentId = current.id;
            const currentName = current.name;

            breadcrumbs.unshift({
              template: () => (
                <span
                  className="p-breadcrumb-link"
                  onClick={() => handleFolderClick(currentId)}
                >
                  {currentName}
                </span>
              ),
            });
          }
          current = findParentFolder(documents.folders, current.parent_id);
        }
        return breadcrumbs;
      };

      setItems(buildBreadcrumbs(currentFolder));
    } else {
      setItems([]);
    }
  }, [currentFolder, documents]);

  const show = (position) => {
    setPosition(position);
    setVisible(true);
  };

  const showFile = (position) => {
    setPosition(position);
    setFileVisible(true);
  };

  const handleSubmitFile = async (data) => {
    setLoader(true);
    const sendData = {
      belong_id: parseInt(id),
      type: "drive_enterprise",
      ...(currentFolderId !== null && { folder_id: parseInt(currentFolderId) }),
      files: [
        {
          name: data.newArchive,
          desc: data.newArchive,
          file: document,
        },
      ],
    };

    try {
      const res = await postEnterpriseDrive(sendData);
      const newFile = res.data[0]; // Assumindo que res.data contém os dados do novo arquivo
      //      console.log("New File: ", { ...newFile, id: newFile.folder_id });
      if (!currentFolder) {
        await refetchDocuments(); // Refetch se currentFolder for null
      } else {
        // Atualizar localmente sem buscar novamente no banco de dados
        const updatedFolders = documents.folders.map((folder) => {
          if (folder.id === currentFolderId) {
            return {
              ...folder,
              files: [...folder.files, { ...newFile, id: newFile.folder_id }],
            };
          }
          return folder;
        });
        //        console.log("Update Folders: ", updatedFolders);
        documents.folders = updatedFolders;
        //        console.log("Docs Folders: ", updatedFolders);
        setCurrentFolder(
          updatedFolders.find((folder) => folder.id === currentFolderId)
        );
      }

      setLoader(false);
      setFileVisible(false);
      toast.success("Arquivo anexado com sucesso!");
    } catch (error) {
      toast.error("Erro ao anexar o arquivo.");
      console.error(error);
      setLoader(false);
    }
  };

  const handleSubmitFolder = async (data) => {
    setLoader(true);
    const sendData = {
      name: data.newPaste,
      type: "drive_enterprise",
      enterprise_id: parseInt(id),
      ...(currentFolderId !== null && { parent_id: parseInt(currentFolderId) }),
    };

    try {
      const res = await postEnterpriseFolder(sendData);
      const newFolder = { ...res.data, files: [], children_folder: [] }; // Assumindo que res.data contém os dados da nova pasta
      //      console.log("New Folder: ", newFolder);
      if (!currentFolder) {
        await refetchDocuments(); // Refetch se currentFolder for null
      } else {
        // Atualizar localmente sem buscar novamente no banco de dados
        const updatedFolders = documents.folders.map((folder) => {
          if (folder.id === currentFolderId) {
            //            console.log("Folder: ", folder);
            return {
              ...folder,
              children_folder: [...folder.children_folder, newFolder],
            };
          }
          return folder;
        });
        //        console.log("Update Folders: ", updatedFolders);
        documents.folders = updatedFolders;
        //        console.log("Docs Folders: ", documents.folders);
        setCurrentFolder(
          updatedFolders.find((folder) => folder.id === currentFolderId)
        );
      }

      setLoader(false);
      setVisible(false);
      toast.success("Pasta criada com sucesso!");
    } catch (error) {
      toast.error(error.errors.name[0]);
      //      console.log(error);
      setLoader(false);
    }
  };

  const handleFolderClick = (folderId) => {
    // console.log("folderId: ", folderId)
    // console.log("currentFolder: ", currentFolder)

    const findFolder = (folders, id) => {
      // console.log("folders: ", folders)

      for (let folder of folders) {
        // console.log("folder: ", folder)
        if (folder.id === id) return folder;
        if (folder.children_folder.length > 0) {
          const found = findFolder(folder.children_folder, id);
          //          // console.log("Found: ", found)
          if (found) return found;
        }
      }
      return null;
    };

    const folder = findFolder(documents.folders, folderId);
    setCurrentFolderId(folderId !== 0 ? folderId : null);
    setCurrentFolder(folder);
  };

  const handleDeleteFile = async (fileId) => {
    setLoader(true);

    try {
      // Chamada para deletar o arquivo no backend
      await deleteDocumentsContracts(fileId);

      // Atualizar localmente sem buscar novamente no banco de dados
      const updatedFiles = documents.files.filter((file) => file.id !== fileId);
      documents.files = updatedFiles;

      if (currentFolder) {
        // Atualizar a pasta atual se necessário
        const updatedCurrentFolder = {
          ...currentFolder,
          files: currentFolder.files.filter((file) => file.id !== fileId),
        };
        setCurrentFolder(updatedCurrentFolder);
      } else {
        await refetchDocuments(); // Refetch se currentFolder for null
      }

      setLoader(false);
      toast.success("Arquivo deletado com sucesso!");
    } catch (error) {
      toast.error("Erro ao deletar o arquivo.");
      //      console.log(error);
      setLoader(false);
    }
  };

  const handleDeleteFolder = async (fId) => {
    setLoader(true);
    // console.log("Folder ID: ", fId);
    // console.log("Documents: ", documents);
    // console.log("Documents Filter: ", documents.folders.filter((folder) => folder.id !== fId));
    // console.log("Current Folder: ", currentFolder);
    const notification = toast.loading("Por favor aguarde...");
    try {
      // Chamada para deletar o arquivo no backend
      await deleteFolder(fId);

      // Atualizar localmente sem buscar novamente no banco de dados
      const updatedFolders = documents.folders.filter((folder) => folder.id !== fId);
      documents.folders = updatedFolders;

      if (currentFolder) {
        // Atualizar a pasta atual se necessário
        const updatedCurrentFolder = {
          ...currentFolder,
          children_folder: currentFolder.children_folder.filter((folder) => folder.id !== fId),
        };
        setCurrentFolder(updatedCurrentFolder);
        setLoader(false);
        toast.update(notification, {
          render: "Arquivo deletado com sucesso!",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      } else {
        await refetchDocuments(); // Refetch se currentFolder for null
        setLoader(false);
        toast.update(notification, {
          render: "Arquivo deletado com sucesso!",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      }
    } catch (error) {
      console.log(error)
      toast.update(notification, {
        render: error.response.data.error,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoader(false);
    }
    refetchDocuments();
  };

  if (loadingDocuments)
    return (
      <div className="row mt-4 pt-4">
        {Array.from({ length: 4 }).map((i) => (
          <div
            key={i}
            className="col-xl-3 col-md-6 col-sm-12 pb-4 card-animation"
          >
            <Skeleton width="100%" height="250px"></Skeleton>
          </div>
        ))}
      </div>
    );

  const folders = currentFolder
    ? currentFolder.children_folder
    : documents.folders;
  const files = currentFolder ? currentFolder.files : documents.files;
  const home = {
    template: () => (
      <span className="p-breadcrumb-link" onClick={() => handleFolderClick(0)}>
        <i className="fa fa-home"></i>
      </span>
    ),
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 pb-4">
          <div className="row">
            {items && items.length > 0 ? (
              <div className="col-md-9">
                <BreadCrumb
                  home={home}
                  model={items}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "16px",
                  }}
                />
              </div>
            ) : (
              <div className="col-md-9"></div>
            )}
            {permissions && permissions.includes("75") && ( //Adicionar Anexos
              <div className="col-md-3 float-end">
                <SplitButton
                  label="Anexar Arquivo"
                  icon="fa fa-plus"
                  model={spreadsheet}
                  onClick={showFile}
                  rounded
                  className="w-100 pb-2 meuComponente"
                />
              </div>
            )}
          </div>
        </div>

        {folders.map((folder) => (
          <CardDocument
            key={folder.id}
            idDoc={folder.id}
            date={">"}
            // fileName={folder.name}
            actions={true}
            deleteFunction={handleDeleteFolder}
            doNotDelete={permissions && !permissions.includes("76")}
            size={`Arquivos: ${folder.files.length}`}
            description={folder.name}
            onClick={() => handleFolderClick(folder.id)}
            type={"folder"}
          />
        ))}

        {files &&
          files.length > 0 &&
          files.map((file) => (
            <CardDocument
              key={file.id}
              idDoc={file.id}
              date={formatDate(file.created_at)}
              description={`${file.name}.${file.path
                .split(".")
                .pop()
                .toLowerCase()}`}
              actions={true}
              hasLink={true}
              hasViewFile={true}
              deleteFunction={handleDeleteFile}
              doNotDelete={permissions && !permissions.includes("76")}//Deletar Anexos
              // fileName={`${file.name}.${file.path.split(".").pop().toLowerCase()}`}
              size={`Tam: ${(file.size / (1024 * 1024)).toFixed(2)}mb`}
              type={file.path.split(".").pop().toLowerCase()}
            />
          ))}

        {files && files.length <= 0 && folders && folders.length <= 0 && (
          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <img src={noData} alt="error" width="400px" />
            <h4>Não encontramos nenhum documento ou pasta por aqui</h4>
          </div>
        )}
      </div>

      <Modal
        visible={visible}
        position={position}
        onHide={() => setVisible(false)}
        dynamicTitle="Nova Pasta"
        dynamicWidth={window.innerWidth <= 992 ? "85vw" : "25vw"}
      >
        <form onSubmit={formPaste.handleSubmit(handleSubmitFolder)}>
          <Input
            errors={errorsPaste}
            control={formPaste.control}
            name="newPaste"
            label="Nova Pasta"
            isRequired={true}
          />
          <div className="d-flex justify-content-end mt-4">
            <Button
              label="Criar"
              icon="pi pi-check"
              type="submit"
              autoFocus
              loading={loader}
            />
          </div>
        </form>
      </Modal>

      <Modal
        visible={fileVisible}
        position={position}
        onHide={() => setFileVisible(false)}
        dynamicTitle="Anexar arquivo"
      >
        <form onSubmit={formFile.handleSubmit(handleSubmitFile)}>
          <div className="row">
            <div className="card p-3 bg-cyan-300 rounded-3 bg-opacity-75">
              <span className="text-blue-800">
                <i className="fa-solid fa-circle-info me-1"></i>
                <b>Atenção</b>: Anexe os arquivos no tipo <b>correspondente</b>{" "}
                de cada arquivo.
              </span>
            </div>
          </div>
          <Input
            errors={errorsFile}
            control={formFile.control}
            name="newArchive"
            label="Nome do Arquivo*"
            isRequired={true}
          />
          <FileInput
            name="archive"
            base64={true}
            setSelectedFile={setDocument}
            doc="Arquivo"
            icon="fa-file"
          />
          <div className="d-flex justify-content-end mt-4">
            <Button
              label="Criar"
              icon="pi pi-check"
              type="submit"
              autoFocus
              loading={loader}
            />
          </div>
        </form>
      </Modal>
    </>
  );
};

export default Documents;
